<div class="c-card">
	<div class="c-content u-no-p@up-to-md">
		<table-transactions [(transactions)]="vm.transactions" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></table-transactions>
	</div>
	<div *ngIf="vm.transactions && vm.transactions?.length > vm.pageSize">
		<div class="o-grid u-ost-md u-osb-md">
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
				<list-pager [totalItems]="vm.transactions.length" [pageSize]="vm.pageSize" [(currentPage)]="vm.currentPage" (currentPageChange)="vm.currentPageChanged($event)"></list-pager>
			</div>
		</div>
	</div>
</div>
